import { IconProps } from './IconProps';

export const LightningBlack = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_31_4)">
        <path
          d="M20.0484 11.7617L9.54844 23.0117C9.43717 23.1305 9.2903 23.2098 9.12998 23.2377C8.96966 23.2657 8.80461 23.2407 8.65972 23.1667C8.51483 23.0926 8.39796 22.9734 8.32676 22.827C8.25556 22.6807 8.23388 22.5152 8.265 22.3555L9.63938 15.4808L4.23657 13.452C4.12053 13.4086 4.01706 13.3372 3.93539 13.244C3.85372 13.1508 3.79639 13.0389 3.76854 12.9182C3.74068 12.7975 3.74316 12.6718 3.77575 12.5522C3.80834 12.4327 3.87004 12.3231 3.95532 12.2333L14.4553 0.983274C14.5666 0.864526 14.7135 0.785191 14.8738 0.75724C15.0341 0.729289 15.1992 0.75424 15.344 0.828326C15.4889 0.902412 15.6058 1.02161 15.677 1.16794C15.7482 1.31428 15.7699 1.47979 15.7388 1.63952L14.3606 8.52171L19.7634 10.5476C19.8786 10.5913 19.9813 10.6627 20.0623 10.7555C20.1433 10.8483 20.2003 10.9596 20.2281 11.0796C20.2559 11.1996 20.2537 11.3246 20.2217 11.4436C20.1897 11.5626 20.1289 11.6718 20.0447 11.7617H20.0484Z"
          fill={props.fill ?? '#000000'}
        />
      </g>
      <defs>
        <clipPath id="clip0_31_4">
          <rect width="24" height="24" fill={props.fill ?? '#000000'} />
        </clipPath>
      </defs>
    </svg>
  );
};

